import { baseSplitApi } from '../baseApi';

const rfpBasePath = "/rfq";
const rfpEndClientBasePath = `${rfpBasePath}/end_client`

export const GET_ALL_RFP_TAG = 'GET_ALL_RFP'
export const GET_ALL_RFP_FOR_END_CLIENT = 'GET_ALL_RFP_FOR_END_CLIENT'

export const rfqApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getAllProposals: build.query({
      query: () => {
        return {
          url: `${rfpBasePath}`,
          method: 'GET',
        }
      },
      providesTags: [GET_ALL_RFP_TAG]
    }),
    getAProposal: build.query({
      query: (id) => {
        return {
          url: `${rfpBasePath}/${id}`,
          method: 'GET',
        }
      }
    }),
    sendProposalToSPoc: build.mutation({
      query: (body) => {
        return {
          url: `${rfpBasePath}/send_proposal_to_spoc`,
          method: "POST",
          body
        }
      },
      invalidatesTags: [GET_ALL_RFP_TAG]
    }),
    getAllProposalsForEndClient: build.query({
      query: () => {
        return {
          url: `${rfpEndClientBasePath}`
        }
      },
      transformResponse: response => response.proposalsForEndClient,
      providesTags: [GET_ALL_RFP_FOR_END_CLIENT]
    }),
    addProposalForEndClient: build.mutation({
      query: (body) => {
        return {
          url: `${rfpEndClientBasePath}?clientCode=${body.clientCode}`,
          method: 'POST',
          body
        }
      },
      invalidatesTags: [GET_ALL_RFP_FOR_END_CLIENT]
    }),
    getAProposalForEndClient: build.query({
      query: (_id) => {
        return {
          url: `${rfpEndClientBasePath}/${_id}`
        }
      },
    }),
    generateViewForProposalTemplateEndClient: build.mutation({
      query: ({clientCode, requestCode, isSendNotification = false}) => {
        return {
          url:`${rfpEndClientBasePath}/generate_view_for_proposal?clientCode=${clientCode}&requestCode=${requestCode}&isSendNotification=${isSendNotification}`,
          method:"POST"
        }
      },
      invalidatesTags:[GET_ALL_RFP_FOR_END_CLIENT]
    }),
   generateProposalLink: build.mutation({
      query: (body) => {
        return {
          url: `${rfpBasePath}/get_proposal_link`,
          method: "POST",
          body
        }
      },
      invalidatesTags: [GET_ALL_RFP_TAG]
    }),
    
  }),
  overrideExisting: false,
})

// These hooks gets auto generated based on endpoints
export const { useGetAllProposalsQuery, useGetAProposalQuery, useSendProposalToSPocMutation, useAddProposalForEndClientMutation, useGetAProposalForEndClientQuery, useGetAllProposalsForEndClientQuery, useGenerateViewForProposalTemplateEndClientMutation, useGenerateProposalLinkMutation } = rfqApi;